// NOTE:
// YOU BETTER READ THIS IF YOU USE THIS!
// This component takes in a NodeList and renders the nodes as is.
// Those nodes better be sanitized and safe to render.
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { Alert, Grid, IconButton, Typography } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

import { v4 as uuid } from 'uuid';

const GridControlsPos = styled(Grid)(() => ({
  '&.MuiGrid-root': {
    position: 'absolute',
    zIndex: '2',
    fontSize: '0.875em',
    paddingRight: '10px',
    marginTop: '20px',
    right: '0px',
    width: '100px',
  },
}));

const NoticeCarousel = ({ notices, styleOptions }) => {
  const noticeArray = Array.from(notices);

  const renderNotices = noticeArray.map((notice) => (
    <div key={`notice-${uuid}`}>
      <Alert severity="warning" sx={{ paddingRight: '100px', color: styleOptions.color, backgroundColor: styleOptions.backgroundColor, fontSize: styleOptions.fontSize }}>
        { /* eslint-disable-next-line react/no-danger */ }
        <div dangerouslySetInnerHTML={{ __html: notice.outerHTML }} />
      </Alert>
    </div>
  ));

  const sliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);

  const goToPrevious = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
      setCurrentSlide((prevSlide) => {
        return (prevSlide === 0 ? (notices.length - 1) : prevSlide - 1);
      }); // Adjust for infinite loop
    }
  };

  const goToNext = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
      setCurrentSlide((prevSlide) => {
        return (prevSlide === (notices.length - 1) ? 0 : prevSlide + 1);
      }); // Adjust for infinite loop
    }
  };

  const handleAfterChange = (current) => {
    setCurrentSlide(current);
  };

  const gridStyle = { position: 'sticky', top: '35px' };
  if (styleOptions?.zIndex) {
    gridStyle.zIndex = styleOptions.zIndex;
  }

  return (
    <Grid container style={gridStyle}>
      { noticeArray.length > 1 && (
        <GridControlsPos item xs={6} container alignItems="center" justifyContent="flex-end">
          <IconButton sx={{ p: 0 }} onClick={goToPrevious}>
            <ChevronLeft />
          </IconButton>
          <Typography variant="body1">
            {currentSlide + 1}
            &nbsp;of&nbsp;
            {noticeArray.length}
          </Typography>
          <IconButton sx={{ p: 0 }} onClick={goToNext}>
            <ChevronRight />
          </IconButton>
        </GridControlsPos>
      )}
      <Grid item xs={12} mt={1}>
        <Slider
          dots={false}
          infinite // Enable infinite scrolling
          speed={500}
          slidesToShow={1}
          slidesToScroll={1}
          ref={sliderRef}
          afterChange={handleAfterChange}
          className="alert-slider"
          arrows={false}
        >
          { renderNotices }
        </Slider>
      </Grid>
    </Grid>
  );
};

NoticeCarousel.defaultProps = {
  notices: [],
  styleOptions: {},
};

NoticeCarousel.propTypes = {
  notices: PropTypes.instanceOf(NodeList),
  styleOptions: PropTypes.object,
};

export default NoticeCarousel;
